// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75fe8e94","453":"f0b5e919","455":"fdfde532","977":"3f21be94"}[chunkId] + ".chunk.js";
};